"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
ProductMarkersDirective.$inject = ['config'];
function ProductMarkersDirective(config) {
    return {
        scope: {
            product: '=',
            size: '@'
        },
        template: require('./views/product-markers.html'),
        link: function (scope, element, attrs, ngModel) {
            scope.markers = [];
            if (scope.product._markers) {
                try {
                    scope.markers = JSON.parse(scope.product._markers)
                        .filter(function (marker) { return marker.b2b_marker === 1; })
                        .map(function (marker) {
                        return __assign({}, marker, { img_url: marker.img_url && marker.img_url.length > 0 ? config.server.storageUrl + marker.img_url : null });
                    });
                }
                catch (e) {
                    console.log(e);
                }
            }
        }
    };
}
exports.ProductMarkersDirective = ProductMarkersDirective;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/shop/directives/ProductMarkersDirective.ts
// module id = 373
// module chunks = 0